module.exports = __webpack_public_path__ + "static/amazon-4418a2823942520b6a38b4df7b06a5aa.jpg";